<template>
  <div id="page-options" class="options">
    <!-- 标题 -->
    <van-nav-bar left-arrow title="个人中心" @click-left="$router.replace({ path: '/user' })" :z-index="10"></van-nav-bar>

    <!-- 等级 -->
    <!-- <van-cell-group class="options-user-info options-links">
      <van-cell class="options-portrait">
        <template slot="icon">
          <img class="options-portrait-img" src="../../assets/img/options/u18.png" alt />
        </template>
        <template slot="title">
          <div class="options-portrait-info">
            <div class="options-pi-title">{{ userInfo.name }} ({{ userInfo.phone }})</div>
            <div class="options-pi-level" v-show="false">
              <div class="options-pil-name">青铜等级</div>
              <div class="options-pil-icon">
                <img src="../../assets/img/options/u17.png" alt />
              </div>
            </div>
          </div>
        </template>
      </van-cell>
    </van-cell-group>
    <div style="height: 8px; background-color: #F1F5F8"></div>-->

    <!-- 列表信息 -->
    <van-cell-group class="options-list options-links">
      <!-- 实名信息 -->
      <van-cell is-link :class="['menu', { 'options-list-item-active': userInfo.isAuthName }]" :value="userInfo.isAuthName ? '已认证' : '未认证'" @click="clickRealname">
        <div slot="title">
          <span class="van-cell-text">实名信息</span>
        </div>
      </van-cell>

      <!-- 风险评测 -->
      <!-- @click="onTomenu('questions')" -->
      <van-cell :class="[
          'menu',
          { 'options-list-item-active': userInfo.userLevel > 0 }
        ]" :value="userInfo.riskMsg" is-link @click="onTo('riskAssessment')">
        <div slot="title">
          <span class="van-cell-text">风险测评</span>
        </div>
      </van-cell>

      <!-- 银行卡管理 -->
      <!-- <van-cell
        :class="['menu',getActiveClass(bankcard.count !== '')]"
        :value="bankcard.count"
        is-link
        @click="onTo('cardlist')"
      >
        <template slot="title">
          <span class="van-cell-text">银行卡管理</span>
        </template>
      </van-cell> -->

      <!-- 收货地址 -->
      <van-cell v-if="
          channel && ['bl', 'zn', 'tajk', 'nyt'].includes(channel.toLowerCase())
        " class="menu" title="收货地址" is-link :to="{ name: 'address' }"></van-cell>

      <!-- 密码管理 -->
      <!-- <van-cell v-if="os!='mini'" class="menu" title="密码管理" is-link @click="onTo('gesture')"></van-cell> -->

      <!-- 登录密码设置 -->
      <van-cell class="menu" title="登录密码设置" is-link @click="onLoginPwdSett"></van-cell>
      <!-- 微信绑定设置 -->
      <!-- <van-cell
        v-if="isWechant()"
        class="menu"
        title="微信绑定"
        is-link
        :value="userInfo.wxAuth ? '已绑定' : '未绑定'"
        @click="onHandleWechat"></van-cell> -->
      <!-- 更换手机 -->
      <van-cell class="menu last" title="更换手机号" is-link @click="$router.push({ name: 'changephone' })">{{ userInfo.phone }}</van-cell>
      <van-cell v-if="userInfo.codeEnable" class="menu" title="更新默认验证码" is-link @click="onUpdateDefaultCode"></van-cell>
    </van-cell-group>
  </div>
</template>

<script>
import * as CustApi from "@/api/cust"
import {
  Row,
  Col,
  Icon,
  Cell,
  CellGroup,
  NavBar,
  Button,
  Dialog,
  Toast
} from "vant"
import { mapActions, mapGetters, mapMutations } from "vuex"
// import { authorize } from "../../assets/js/authorize"
import session from "../../utils/session"

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [CellGroup.name]: CellGroup,
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Dialog.name]: Dialog
  },

  data() {
    return {
      user_info: {
        authName: "",
        phone: ""
      },
      bankcard: {
        list: [],
        count: ""
      },
      risks: {
        level: ""
      },
      isLoadAuthCode: false
    }
  },

  watch: {
    "bankcard.list"(newVal, oldVal) {
      if (newVal && newVal.length) {
        this.bankcard.count = newVal.length + "张"
      } else {
        this.bankcard.count = ""
      }
    }
  },

  beforeMount() {
    this.getBindCardList()
  },

  computed: {
    getActiveClass(isActive) {
      return (isActive) => {
        if (isActive) {
          return "options-list-item-active"
        }
      }
    },
    ...mapGetters(["os", "channel", "userInfo"])
  },

  methods: {
    ...mapActions(["getUserInfo"]),

    onLoggingOut() {
      // Dialog.confirm({
      //     title: "提示",
      //     message: "确认立即退出当前账号 !"
      // }).then(() => {
      //     localStorage.clear();
      //     this.$router.push("login");
      // })

      this.$store.commit("logout")
      this.$router.push("/login")
    },
    clickRealname() {
      // :to="userInfo.isAuthName ? {name:'realname-view'} : {name:'realname'}"
      if (this.userInfo.isAuthName) {
        this.$toast("已实名")
      } else {
        session.setJson("cq", undefined)
        this.$router.push({ name: "realname" })
      }
    },
    onLoginPwdSett() {
      session.setJson("RegisterAndForgetPwdKey", {
        type: 4,
        mobile: ""
      })
      this.$router.push({
        name: "personalCenter-loginpwd4"
      })
    },
    onUpdateDefaultCode() {
      session.setJson("cq", undefined)
      this.$router.push({ name: "updateDefaultCode" })
    },
    onTo(path) {
      session.setJson("cq", undefined)
      const query = { from: "options" }
      let _allow = true //  是否允许前往下一页
      let _dialog = ""

      switch (path) {
        case "realname":
          // _allow = this.userInfo.isAuthName ? false : true;
          _allow = true
          break
        case "cardlist":
          _allow = true
          break
        case "questions":
          _allow = true
          _dialog = this.userInfo.userLevel < 1 ? "" : "是否重新测评"
          break
        case "gesture":
          _allow = true
          break
        case "riskAssessment":
          _allow = !this.userInfo.isAuthName ? false : true
          break
        default:
          break
      }
      if (!_allow) {
        if (path == "riskAssessment") {
          //未设置实名
          Dialog.alert({
            title: "温馨提示",
            message: "您还未实名，请先去实名认证？",
            confirmButtonText: "去实名",
            showCancelButton: true,
            theme: "round-button"
          })
            .then(() => {
              this.$router.push({ name: "realname" })
            })
            .catch(() => { })
        }
        return
      }

      // this.$router.push({path: '/risksResults'})
      if (_dialog) {
        Dialog.confirm({ title: "提示", message: _dialog }).then(() => {
          this.$router.push({
            name: path,
            query: Object.assign(
              { redirect: this.$route.query.redirect },
              query
            )
          })
        })
      } else {
        this.$router.push({
          name: path,
          query: Object.assign({ redirect: this.$route.query.redirect }, query)
        })
      }
    },
    /*
    onHandleWechat() {
      if (this.userInfo.wxAuth) {
        Dialog.alert({
          title: "温馨提示",
          message: "是否需要解除微信绑定？",
          confirmButtonText: "确认",
          showCancelButton: true,
          theme: "round-button"
        })
          .then(() => {
            this.deleteWechatBind()
          })
          .catch(() => {})
      } else {
        Dialog.alert({
          title: "温馨提示",
          message: "是否需要添加微信绑定？",
          confirmButtonText: "确认",
          showCancelButton: true,
          theme: "round-button"
        })
          .then(() => {
            this.getWechatBind()
          })
          .catch(() => {})
      }
    },
    getWechatBind() {
      localStorage.setItem("wechat_auth_status", "startWechatBind")
      authorize(location.href.split("#")[0] + "#/personalCenter")
    },
    deleteWechatBind() {
      this._showLoading()
      CustApi.deleteWechatBind()
        .then((data) => {
          this._dismissLoading()
          this.getUserInfo().then(() => {})
        })
        .catch((e) => {
          this._dismissLoading()
          Toast(e.msg || e.message)
        })
    },*/
    getBindCardList() {
      CustApi.listBindCard()
        .then((data) => {
          this.bankcard.list = data || []
          if (data.length > 0) {
            this.bankcard.count = data.length + "张"
          } else {
            this.bankcard.count = "前往绑定"
          }
        })
        .catch((e) => {
          Toast(e.msg || e.message)
        })
    }
  }
}
</script>

<style lang="less" scoped>
// 下边框线条
::v-deep .van-cell.menu:not(:last-child)::after {
  border: none;
}

::v-deep .van-cell {
  border-bottom: 1px solid #ebebeb;
  .van-cell__title {
    color: #666;
    font-size: 15px;
  }
}

.last {
  border: none;

  .van-cell__value {
    color: #999;
    font-size: 14px;
  }
}

// --------------------------------------------------
.options {
  background-color: #f1f5f8;
  min-height: 100vh;
  position: relative;

  &-links {
    &-img {
      width: 20px;
      height: 20px;
      top: 2px;
      margin-right: 10px;
    }
  }

  &-user-info {
    > .van-cell {
      padding-top: 20px;
      padding-bottom: 20px;
    }
  }

  &-list {
    padding: 0 20px;

    > .options-list-item-active {
      .van-cell__value {
        color: #999;
        font-size: 14px;
      }
    }
  }

  &-portrait {
    &-img {
      width: 50px;
      height: 50px;
      position: relative;
    }
    &-info {
      margin-left: 14px;
      margin-top: 12px;
    }
    .options-pi-title,
    .options-pi-level {
      line-height: 1;
    }
    .options-pi-title {
    }
    .options-pi-level {
      margin-top: 4px;
      font-size: 10px;
      color: #6f4829;
    }
    .options-pil-name,
    .options-pil-icon {
      display: inline-block;
      vertical-align: middle;
    }
    .options-pil-name {
    }
    .options-pil-icon {
      > img {
        width: 10px;
        margin-left: 6px;
      }
    }
  }

  &-control {
    background-color: transparent;
    position: absolute;
    bottom: 0;
  }
}
</style>
